import React from 'react';
import { UseFormMethods } from 'react-hook-form';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFLegend from 'src/components/controls/tempRHFControls/RHFLegend';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import CurativeRequirement from 'src/models/CurativeRequirement';
import IndexReferenceType from 'src/models/IndexReferenceType';
import Landman from 'src/models/Landman';

interface ICurativeModuleProps extends Partial<Pick<UseFormMethods, 'register' | 'errors'>> {
    curativeRequirements: Array<CurativeRequirement>;
    runsheetId: number;
    curativeStatuses: Array<IndexReferenceType>;
    projectStaff: Array<Landman>;

    addRow: () => void;
    deleteRow: (index: number) => void;
    updateCurativeRequirements: () => void;
}

const CurativeModule = (props: ICurativeModuleProps) => {
    const paddingRule = '0 1rem 0 1rem';

    const curativeHeader = () => {
        return (
            <div style={{ display: 'flex' }}>
                <div className="mr-2 mb-2" style={{ width: '100%' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ padding: paddingRule, width: '7%' }}>
                            <div>
                                <b>Title Opinion Number</b>
                            </div>
                        </div>
                        <div style={{ padding: paddingRule, width: '15%' }}>
                            <div>
                                <b>Title Defect Issue</b>
                            </div>
                        </div>
                        <div style={{ padding: paddingRule, width: '10%' }}>
                            <div>
                                <b>Status</b>
                            </div>
                        </div>
                        <div style={{ padding: paddingRule, width: '15%' }}>
                            <div>
                                <b>Curative Requirement</b>
                            </div>
                        </div>
                        <div style={{ padding: paddingRule, width: '8%' }}>
                            <div>
                                <b>Date Assigned</b>
                            </div>
                        </div>
                        <div style={{ padding: paddingRule, width: '8%' }}>
                            <div>
                                <b>Completed?</b>
                            </div>
                        </div>
                        <div style={{ padding: paddingRule, width: '10%' }}>
                            <div>
                                <b>Assigned To</b>
                            </div>
                        </div>
                        <div style={{ padding: paddingRule, width: '12%' }}>
                            <div>
                                <b>Brief Description</b>
                            </div>
                        </div>
                        <div style={{ padding: paddingRule, width: '15%' }}>
                            <div>
                                <b>Curative Control Comments</b>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div>
            <RHFLegend title="Curative Module" />
            {props.curativeRequirements?.length > 0 && (
                <>
                    {curativeHeader()}
                    {props.curativeRequirements?.map((curative: CurativeRequirement, index: number) => {
                        return (
                            <div
                                key={`Curative-${index + 1}`}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                }}
                                className="mb-2"
                            >
                                <input type="hidden" name={`curativeRequirements[${index}].id`} ref={props.register()} />
                                <RHFInputBox
                                    name={`curativeRequirements[${index}].titleOpinionReqNo`}
                                    bodyStyle={{ width: '7%' }}
                                    style={{ width: '100%' }}
                                    register={props.register}
                                    errors={props.errors}
                                />
        
                                <RHFInputBox
                                    name={`curativeRequirements[${index}].reqDescription`}
                                    bodyStyle={{ width: '15%' }}
                                    style={{ width: '100%' }}
                                    register={props.register}
                                    errors={props.errors}
                                />
        
                                <RHFSelect
                                    name={`curativeRequirements[${index}].statusId`}
                                    bodyStyle={{ width: '10%' }}
                                    style={{ width: '100%' }}
                                    register={props.register}
                                    errors={props.errors}
                                    options={props.curativeStatuses.map(cs => { return {value: cs.id, label: cs.name}; })}
                                />

                                <RHFInputBox
                                    name={`curativeRequirements[${index}].curativeRemarks`}
                                    bodyStyle={{ width: '15%' }}
                                    style={{ width: '100%' }}
                                    register={props.register}
                                    errors={props.errors}
                                />
        
                                <RHFInputBox
                                    name={`curativeRequirements[${index}].dateAssigned`}
                                    bodyStyle={{ width: '6%' }}
                                    style={{ width: '100%' }}
                                    type="date"
                                    register={props.register}
                                    errors={props.errors}
                                />
        
                                <RHFCheckbox
                                    name={`curativeRequirements[${index}].isCompleted`}
                                    bodyStyle={{ width: '8%', margin: '0' }}
                                    style={{ width: '100%' }}
                                    register={props.register}
                                    errors={props.errors}
                                />
        
                                <RHFSelect
                                    name={`curativeRequirements[${index}].assignedToId`}
                                    bodyStyle={{ width: '10%' }}
                                    style={{ width: '100%' }}
                                    register={props.register}
                                    errors={props.errors}
                                    options={props.projectStaff.map(ps => { return {value: ps.id, label: ps.firstName + ' ' + ps.lastName}; })}
                                />
        
                                <RHFInputBox
                                    name={`curativeRequirements[${index}].briefDescription`}
                                    bodyStyle={{ width: '12%' }}
                                    style={{ width: '100%' }}
                                    register={props.register}
                                    errors={props.errors}
                                />
        
                                <RHFInputBox
                                    name={`curativeRequirements[${index}].curativeControlComments`}
                                    bodyStyle={{ width: '15%' }}
                                    style={{ width: '100%' }}
                                    register={props.register}
                                    errors={props.errors}
                                />

                                <div onClick={() => props.deleteRow(index)} style={{ width: '2%' }}>❌</div>
                            </div>
                        );
                    })}
                </>
            )}
            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '2rem' }}>
                <Button text="Add Requirement" onClick={() => props.addRow()} intent="primary" />
                <Button text="Save Curative Requirements" onClick={() => props.updateCurativeRequirements()} intent="primary" disabled={!(props.curativeRequirements?.length > 0)} />
            </div>
        </div>
    );
};

export default CurativeModule;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/CurativeModule.tsx